import { Component, OnInit, ChangeDetectionStrategy, inject } from "@angular/core";
import { ModalController, IonButton, IonContent, IonHeader, IonIcon, IonItem, IonList, IonTitle, IonToolbar } from "@ionic/angular";
import { SmartComponentType } from "../../enum/enumSmartComponentType";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { IconHelper } from "../../class/icon-helper";
import { PlatformModeContentDirective } from "../../../../directive/platform-mode-content.directive";

@Component({
    selector: "app-add-smart-component",
    templateUrl: "./add-smart-component.component.html",
    styleUrls: ["./add-smart-component.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonContent, IonHeader, IonIcon, IonItem, IonList, IonTitle, IonToolbar, PlatformModeContentDirective, TranslatePipe]
})
export class AddSmartComponentComponent implements OnInit {
  private readonly _modalCtrl = inject(ModalController);
  private readonly _translateService = inject(TranslateService);

  public componentsList: Array<{
    icon: string;
    text: string;
    action: SmartComponentType;
  }> = null;

  ngOnInit() {
    this.initializeComponentsList();
  }

  /**
   * Open specific component page when clicking the button
   * @param componentKind type of the components
   */
  public onClickSelectComponent(componentKind: SmartComponentType): void {
    this._modalCtrl.dismiss({ action: componentKind });
  }

  /**
   * Exit without choosing an option
   */
  public onClickCancel(): void {
    this._modalCtrl.dismiss({ action: "cancel" });
  }

  /**
   * Initialization of components list
   */
  private initializeComponentsList(): void {
    this.componentsList = [
      // {
      //   icon: IconHelper.getSmartComponentIconByType(
      //     SmartComponentType.CONTACT
      //   ),
      //   text: this._lblSwitch,
      //   action: SmartComponentType.CONTACT,
      // },
      {
        icon: IconHelper.getSmartComponentIconByType(SmartComponentType.DIMMER),
        text: this._translateService.instant("dictionary.dimmableLight"),
        action: SmartComponentType.DIMMER,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(SmartComponentType.BLINDS),
        text: this._translateService.instant("dictionary.blind"),
        action: SmartComponentType.BLINDS,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(SmartComponentType.ALARM),
        text: this._translateService.instant("dictionary.alarm"),
        action: SmartComponentType.ALARM,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(
          SmartComponentType.COLD_WATER,
        ),
        text: this._translateService.instant("dictionary.counterColdWater"),
        action: SmartComponentType.COLD_WATER,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(
          SmartComponentType.HOT_WATER,
        ),
        text: this._translateService.instant("dictionary.counterHotWater"),
        action: SmartComponentType.HOT_WATER,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(
          SmartComponentType.ELECTRIC,
        ),
        text: this._translateService.instant("dictionary.counterElectric"),
        action: SmartComponentType.ELECTRIC,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(SmartComponentType.GAS),
        text: this._translateService.instant("dictionary.gasMeter"),
        action: SmartComponentType.GAS,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(
          SmartComponentType.HEATING,
        ),
        text: this._translateService.instant("dictionary.heatCounter"),
        action: SmartComponentType.HEATING,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(
          SmartComponentType.DISTRIBUTOR,
        ),
        text: this._translateService.instant("dictionary.heatAllocator"),
        action: SmartComponentType.DISTRIBUTOR,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(SmartComponentType.LIGHT),
        text: this._translateService.instant("dictionary.typeLights"),
        action: SmartComponentType.LIGHT,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(
          SmartComponentType.THERMOSTAT,
        ),
        text: this._translateService.instant("dictionary.thermostat"),
        action: SmartComponentType.THERMOSTAT,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(SmartComponentType.SENSOR),
        text: this._translateService.instant("dictionary.typeSensor"),
        action: SmartComponentType.SENSOR,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(
          SmartComponentType.WEATHER_STATION,
        ),
        text: this._translateService.instant("dictionary.weatherStation"),
        action: SmartComponentType.WEATHER_STATION,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(SmartComponentType.LABEL),
        text: this._translateService.instant("dictionary.label"),
        action: SmartComponentType.LABEL,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(SmartComponentType.SCENARIO),
        text: this._translateService.instant("dictionary.scenario"),
        action: SmartComponentType.SCENARIO,
      },
      {
        icon: IconHelper.getSmartComponentIconByType(
          SmartComponentType.PAGE_BREAK,
        ),
        text: this._translateService.instant("dictionary.pageBreak"),
        action: SmartComponentType.PAGE_BREAK,
      },
    ];
  }
}
